import React, { createContext, useContext } from 'react';

const ApiContext = createContext();

export const ApiProvider = ({ baseUrl, children }) => {
  return <ApiContext.Provider value={baseUrl}>{children}</ApiContext.Provider>;
};

export const useApiBaseUrl = () => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApiBaseUrl must be used within an ApiProvider');
  }
  return context;
};